import { ReactNode } from "react";
import { Title2, Body1, makeStyles, tokens, shorthands } from "@fluentui/react-components";
import { LandingPageLayout } from "../layouts";
import Background from "./Background";

interface IMessageScreen {
  icon: ReactNode;
  title: string;
  descriptions: string[];
  action?: ReactNode;
}

const useStyles = makeStyles({
  root: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    ...shorthands.padding(tokens.spacingVerticalXXL, tokens.spacingHorizontalL),
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    maxWidth: "440px",
    ...shorthands.padding(tokens.spacingVerticalXXXL, tokens.spacingHorizontalXXL),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    boxShadow: tokens.shadow16,
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "72px",
    height: "72px",
    ...shorthands.borderRadius("50%"),
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
    marginBottom: tokens.spacingVerticalL,
    fontSize: "36px",
  },
  title: {
    marginBottom: tokens.spacingVerticalM,
  },
  description: {
    color: tokens.colorNeutralForeground2,
    marginBottom: tokens.spacingVerticalS,
  },
  action: {
    marginTop: tokens.spacingVerticalL,
  },
});

const MessageScreen: React.FC<IMessageScreen> = ({ icon, title, descriptions, action }) => {
  const styles = useStyles();

  return (
    <LandingPageLayout>
      <Background />
      <div className={styles.root}>
        <div className={styles.card}>
          <div className={styles.iconWrapper} aria-hidden>
            {icon}
          </div>
          <Title2 className={styles.title}>{title}</Title2>
          {descriptions.map((text, index) => (
            <Body1 key={index} className={styles.description}>
              {text}
            </Body1>
          ))}
          {action && <div className={styles.action}>{action}</div>}
        </div>
      </div>
    </LandingPageLayout>
  );
};

export default MessageScreen;
